/**
 * Chat media upload – single-file POST. Same API for admin and mobile.
 * Returns { media: { id, url, kind, original_name, ext } }.
 */

import { chatApi } from './chatApi';

/**
 * @param {Object} opts
 * @param {File} opts.file
 * @param {'image'|'file'|'audio'} opts.kind
 * @param {Function} [opts.onProgress] - optional; single-file upload may not report progress
 * @param {{ uploadMedia: (file: File, kind: string) => Promise<{ data?: { media?: { id: number } } }> }} [opts.api] - use for customer chat (realtimeChatAPI); omit for admin
 * @returns {Promise<{ id: number, url: string, kind: string, original_name: string, ext?: string }>}
 */
export async function uploadChatMedia({ file, kind = 'file', onProgress, api }) {
  const client = api || chatApi;
  const res = await client.uploadMedia(file, kind);
  const media = res.data?.media;
  if (!media?.id) throw new Error('Upload did not return media');
  onProgress?.({ percent: 100 });
  return media;
}
